import UserAccountDetails from './screens/user-account-details/user-account-details'
import Finished from './screens/finished/finished.container'
import UnknownError from './screens/unknown-error/unknown-error'
import TermsAndConditions from './screens/terms-and-conditions/terms-and-conditions.container'
import FSUTeacher from './screens/fsu-teacher/fsu-teacher.container'
import EmailRequired from './screens/email-required/email-required.container'
import EmailConfirmationRequired from './screens/email-confirmation-required/email-confirmation-required.container'
import PasswordRequired from './screens/password-required/password-required'
import UserType from './screens/user-type/user-type'

export default {
  Finished: Finished,
  RoleRequired: UserType,
  UserAccountDetailsRequired: UserAccountDetails,
  TermsAndConditionsAcceptRequired: TermsAndConditions,
  FinishTeacherSignupRequired: FSUTeacher,
  UnknownError: UnknownError,
  EmailIdentityRequired: EmailRequired,
  EmailConfirmationRequired: EmailConfirmationRequired,
  PasswordRequired: PasswordRequired
}
